import {NonNegativeInt} from '@raison/types';
import {fixNumber, formatDoubleStringInput} from '~/shared/utils/tools';

class Currency {
    protected _amount: number | string;
    protected readonly _digits: number;
    transactionsDigits: number;

    constructor(amount: number | string, decimals_assets: NonNegativeInt) {
        this._amount = amount;
        this._digits = decimals_assets;
        this.transactionsDigits = decimals_assets ?? 2;
    }

    get amount(): string {
        return this.getFixedValue(this._digits);
    }

    set amount(amount: number | string) {
        if (/^\d+$|^\d+\.\d*$/.test(amount.toString())) {
            this._amount = amount;
        }
    }

    setAmount(amount: number | string) {
        this._amount = amount;
    }

    getFixedValue(digits: number) {
        return fixNumber(this._amount, undefined, digits);
    }

    get fixedValue() {
        return formatDoubleStringInput(this._amount.toString(), this._digits);
    }

    // preserve trailing dot in the end
    get fixedValueForForms() {
        return formatDoubleStringInput(this._amount.toString(), this._digits, true);
    }

    get decimals() {
        return this._digits;
    }
}

export default Currency;
